import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import ReportPayrollList, { DispatchProps, OwnProps, StateProps } from './ReportPayrollList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getReportPayrolls } from 'src/store/actions/reportPayroll-actions';
import { getPayrollsReportsCsv } from 'src/store/actions/reportPayroll-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.reportPayrolls.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getDataCsv: (params: QueryParams) => dispatch(getPayrollsReportsCsv(params)),
        getData: (params: QueryParams) => dispatch(getReportPayrolls(params)),
    };
}

const ReportPayrollListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ReportPayrollList);

export default ReportPayrollListScreen;
